import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/dramas';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function About() {
  const testimonials = [
    { name: '追剧达人小王', comment: '用了6080影视三年了，画质清晰不卡顿，更新速度真的快，强烈推荐！', rating: 5 },
    { name: '上班族小李', comment: '每天下班后追剧必备，资源齐全，不用再到处找剧了，非常好用。', rating: 5 },
    { name: '剧迷小芳', comment: '界面简洁，操作方便，各种分类清晰，找剧变得特别简单。', rating: 5 },
    { name: '资深影迷老张', comment: '从经典老剧到新剧，资源太丰富了，而且没有广告，体验感极佳。', rating: 5 },
    { name: '学生党小赵', comment: '免费看剧就是爽！不卡顿，画质好，还能看全集，太良心了。', rating: 4 },
    { name: '宝妈小陈', comment: '周末带娃还能追剧，6080影视真是我的救星，感谢这么好的平台。', rating: 5 },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于6080影视',
    url: 'https://www.6080ys.com/about',
    description: siteInfo.description,
    mainEntity: {
      '@type': 'Organization',
      name: siteInfo.name,
      description: siteInfo.description,
      foundingDate: '2018',
      email: siteInfo.email,
      telephone: siteInfo.phone,
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CN',
        addressLocality: '北京',
        streetAddress: siteInfo.address,
      },
      url: 'https://www.6080ys.com/',
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '6080影视是完全免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，6080影视平台所有电视剧资源均免费提供在线观看，无需付费或开通会员。',
        },
      },
      {
        '@type': 'Question',
        name: '观看视频需要下载APP吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要。6080影视支持网页直接播放，无需下载任何客户端或插件。',
        },
      },
      {
        '@type': 'Question',
        name: '视频播放卡顿怎么办？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们采用先进的多线CDN加速技术，一般情况下播放非常流畅。如遇卡顿，可尝试切换播放线路或检查您的网络连接。',
        },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />

      <main className="min-h-screen pt-20">
        {/* Breadcrumb */}
        <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 py-4">
          <ol className="flex items-center gap-2 text-sm">
            <li className="flex items-center">
              <Link to="/" className="text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer">首页</Link>
            </li>
            <li className="flex items-center">
              <span className="text-foreground-600 mr-2">&gt;</span>
              <span className="text-foreground-300">关于我们</span>
            </li>
          </ol>
        </nav>

        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          {/* Hero section */}
          <section className="text-center py-12 md:py-16 mb-12">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-100 mb-4">
              关于
              <span className="text-primary-500">6080</span>影视
            </h1>
            <p className="text-sm md:text-base text-foreground-400 max-w-2xl mx-auto leading-relaxed">
              {siteInfo.description}
            </p>
          </section>

          {/* Brand Story */}
          <section className="mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100 mb-4">
                  <i className="ri-building-line text-primary-500 mr-2"></i>品牌介绍
                </h2>
                <div className="space-y-3 text-sm text-foreground-400 leading-relaxed">
                  <p>6080影视成立于2018年，始终秉承"让每一位观众都能免费享受高品质影视内容"的初心，致力于打造最优质的免费电视剧在线观看平台。</p>
                  <p>经过六年的发展，我们已累计收录超过50000部电视剧资源，涵盖国产剧、韩剧、美剧、日剧、港剧、台剧、泰剧等多个品类，每日实时更新最新剧集。</p>
                  <p>我们坚持使用高清流媒体技术，确保用户获得流畅不缓冲的观看体验。无论是热门新剧还是经典老剧，6080影视都能满足您的追剧需求。</p>
                </div>
              </div>
              <div className="rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20sleek%20digital%20entertainment%20platform%20interface%20showing%20TV%20shows%20on%20a%20large%20curved%20screen%20in%20a%20dark%20elegant%20room%2C%20cinematic%20warm%20lighting%2C%20technology%20meets%20entertainment%20aesthetic%2C%20professional%20and%20trustworthy%20atmosphere%2C%20dark%20background%20with%20subtle%20gold%20accents&width=800&height=600&seq=about-brand&orientation=landscape"
                  alt="6080影视品牌"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          {/* Platform advantages */}
          <section className="bg-background-100/50 rounded-2xl p-8 md:p-10 mb-16">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
                <i className="ri-shield-star-line text-accent-500 mr-2"></i>平台优势
              </h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-hd-line', title: '超清画质', desc: '支持1080P高清播放，每一帧都清晰可见' },
                { icon: 'ri-flashlight-line', title: '极速不缓冲', desc: '采用先进CDN加速，流畅播放无需等待' },
                { icon: 'ri-database-2-line', title: '海量资源', desc: '50000+部电视剧，涵盖各类型和地区' },
                { icon: 'ri-refresh-line', title: '每日更新', desc: '紧跟最新剧集，确保第一时间上线' },
              ].map((item) => (
                <div key={item.title} className="text-center">
                  <div className="w-14 h-14 mx-auto mb-4 bg-background-50 rounded-xl flex items-center justify-center border border-background-300/60">
                    <i className={`${item.icon} text-2xl text-primary-500`}></i>
                  </div>
                  <h3 className="text-sm font-bold text-foreground-200 mb-2">{item.title}</h3>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Testimonials */}
          <section className="mb-16">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
                <i className="ri-heart-pulse-line text-secondary-500 mr-2"></i>用户口碑
              </h2>
              <p className="text-sm text-foreground-500 mt-1">来自真实用户的评价</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="bg-background-50 rounded-xl p-5 border border-background-300/60">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }, (_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < t.rating ? 'ri-star-fill text-primary-500' : 'ri-star-line text-foreground-700'}`}
                      ></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-300 leading-relaxed mb-4">"{t.comment}"</p>
                  <p className="text-xs text-foreground-500">— {t.name}</p>
                </div>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-background-100/50 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-bold text-foreground-100 mb-6">
                  <i className="ri-contacts-line text-primary-500 mr-2"></i>联系我们
                </h2>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center border border-background-300/60 shrink-0">
                      <i className="ri-map-pin-line text-sm text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">地址</p>
                      <p className="text-sm text-foreground-300 mt-0.5">{siteInfo.address}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center border border-background-300/60 shrink-0">
                      <i className="ri-mail-line text-sm text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">邮箱</p>
                      <p className="text-sm text-foreground-300 mt-0.5">{siteInfo.email}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center border border-background-300/60 shrink-0">
                      <i className="ri-phone-line text-sm text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电话</p>
                      <p className="text-sm text-foreground-300 mt-0.5">{siteInfo.phone}</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 rounded-lg bg-background-50 flex items-center justify-center border border-background-300/60 shrink-0">
                      <i className="ri-calendar-line text-sm text-primary-500"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">成立时间</p>
                      <p className="text-sm text-foreground-300 mt-0.5">{siteInfo.founded}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-100/50 rounded-2xl p-8">
                <h2 className="text-xl font-heading font-bold text-foreground-100 mb-6">
                  <i className="ri-message-3-line text-accent-500 mr-2"></i>留言反馈
                </h2>
                <form
                  data-readdy-form
                  onSubmit={(e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                    if (btn) {
                      btn.textContent = '发送成功!';
                      btn.disabled = true;
                      setTimeout(() => {
                        btn.textContent = '提交反馈';
                        btn.disabled = false;
                        form.reset();
                      }, 2000);
                    }
                  }}
                >
                  <div className="space-y-4">
                    <div className="spamcheck">
                      <input type="text" name="company_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly >/</input>
                    </div>
                    <input
                      type="text"
                      name="name"
                      placeholder="您的姓名"
                      className="w-full bg-background-50 text-foreground-200 text-sm rounded-lg px-4 py-3 border border-background-300/60 focus:border-primary-500 outline-none transition-all duration-200 placeholder:text-foreground-600"
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      className="w-full bg-background-50 text-foreground-200 text-sm rounded-lg px-4 py-3 border border-background-300/60 focus:border-primary-500 outline-none transition-all duration-200 placeholder:text-foreground-600"
                    />
                    <textarea
                      name="message"
                      rows={4}
                      maxLength={500}
                      placeholder="请输入您的留言（最多500字）"
                      className="w-full bg-background-50 text-foreground-200 text-sm rounded-lg px-4 py-3 border border-background-300/60 focus:border-primary-500 outline-none transition-all duration-200 resize-none placeholder:text-foreground-600"
                    ></textarea>
                    <button
                      type="submit"
                      className="w-full py-3 bg-primary-500 text-background-950 font-medium rounded-lg text-sm hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
                    >
                      提交反馈
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-16">
            <div className="text-center mb-10">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">
                <i className="ri-questionnaire-line text-primary-500 mr-2"></i>常见问题
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              {[
                { q: '6080影视是完全免费的吗？', a: '是的，6080影视平台所有电视剧资源均免费提供在线观看，无需付费或开通会员。' },
                { q: '观看视频需要下载APP吗？', a: '不需要。6080影视支持网页直接播放，无需下载任何客户端或插件，打开网页即可观看。' },
                { q: '视频播放卡顿怎么办？', a: '我们采用先进的多线CDN加速技术，一般情况下播放非常流畅。如遇卡顿，可尝试切换播放线路或检查您的网络连接。' },
                { q: '为什么有的剧集没有更新？', a: '我们会尽力在第一时间更新最新剧集。对于仍在更新中的剧集，更新速度取决于播出进度和版权因素。' },
                { q: '可以下载剧集吗？', a: '目前6080影视仅支持在线观看，暂不提供下载服务。我们建议您通过网页直接在线观看以获得最佳体验。' },
                { q: '如何向平台反馈问题？', a: '您可以通过页面底部的联系方式或留言反馈表单联系我们。我们会认真阅读每一条反馈并持续优化平台体验。' },
              ].map((faq, i) => (
                <div key={i} className="bg-background-50 rounded-xl p-5 border border-background-300/60">
                  <h3 className="text-sm font-bold text-foreground-200 mb-2">Q: {faq.q}</h3>
                  <p className="text-xs text-foreground-400 leading-relaxed">A: {faq.a}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </main>
    </>
  );
}